import React from 'react'
import { generatePath, useNavigate } from 'react-router'
import { useEvent } from '@emerald-works/react-event-bus-client'
import { ActionButton, ConfirmationAlert } from '@emerald-works-nova/components'
import { useStyles } from './style'
import { Grid } from '@mui/material'
import { useForm } from 'react-hook-form'
import { Panel, SectionHeader, SkillBiteDetailsForm } from '../../components'
import { routes } from '../../routes'
import { yupResolver } from '@hookform/resolvers/yup'
import { skillBiteFormSchema } from '../../util/skill-bite-schemas'

const SkillBiteNew = () => {
  const classes = useStyles()
  const navigate = useNavigate()
  const form = useForm({
    resolver: yupResolver(skillBiteFormSchema),
    defaultValues: {
      name: '',
      description: '',
      shortDescription: '',
      metaSkill: '',
      skill: '',
      expert: false,
      credlyBadgeTemplateId: ''
    },
    mode: 'all'
  })

  const { errors, isDirty, isValid } = form.formState
  const [showDiscardAlert, setShowDiscardAlert] = React.useState(false)

  const [createSkillBite] = useEvent([
    {
      eventName: 'adminSkillBiteCreate',
      onSuccess: (payload) => {
        navigate(generatePath(routes.skillBiteEdit.path, { skillBiteId: payload.id }))
      },
      onError: (error) => {
        console.log('Error', error)
      }
    }
  ])

  const onSubmit = (data) => {
    createSkillBite.trigger(data)
  }

  const handleDiscard = () => {
    form.reset()
    navigate(routes.skillBiteList.path)
  }

  const handleDiscardAlert = () => {
    const formValues = form.getValues()
    const isEmpty = Object.values(formValues).every(p => (p === null || p === ''))

    if (isDirty && !isEmpty) {
      setShowDiscardAlert(true)
    } else {
      navigate(routes.skillBiteList.path)
    }
  }

  return (
    <div className={classes.root}>
      <form noValidate autoComplete='off' onSubmit={form.handleSubmit(onSubmit)}>
        <Grid
          container
          justifyContent='space-between'
          alignItems='center'
          className={classes.header}
        >
          <Grid item>
            <SectionHeader
              data-test='create-skill-bite-header'
              title='New Skill Bite'
              location='Skill Bites /'
            />
          </Grid>
          <Grid item>
            <ActionButton
              variant='secondary'
              data-test='create-skill-bite-discard-button'
              style={{ marginRight: 22 }}
              onClick={handleDiscardAlert}
              disabled={createSkillBite.isWorking}
            >
              Discard
            </ActionButton>
            <ActionButton
              variant='primary'
              data-test='create-skill-bite-create-button'
              type='submit'
              isWorking={createSkillBite.isWorking}
              disabled={!isValid}
            >
              Create
            </ActionButton>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            <Panel>
              <SkillBiteDetailsForm isReadOnly={createSkillBite.isWorking} form={form} errors={errors} />
            </Panel>
          </Grid>
        </Grid>
      </form>
      <ConfirmationAlert
        title='Discard this new skill bites?'
        description={'If you discard this new skill bites, you\'ll lose all the information that you added.'}
        agreeText='Discard'
        showModal={showDiscardAlert}
        onConfirmation={handleDiscard}
        onCancel={() => setShowDiscardAlert(false)}
      />
    </div>
  )
}

export default SkillBiteNew
